export default function MaterialCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.7153 8.86654L11.4166 9.28729C11.5546 9.37019 11.5994 9.54933 11.5166 9.68746C11.4919 9.72853 11.4576 9.76289 11.4166 9.7875L6.30015 12.8573C6.11541 12.9682 5.88464 12.9682 5.6999 12.8573L0.583546 9.7875C0.445419 9.70461 0.400624 9.52547 0.483504 9.38733C0.508133 9.34627 0.542491 9.31191 0.583546 9.28729L1.28477 8.86654L6.00002 11.6957L10.7153 8.86654ZM10.7153 6.12487L11.4166 6.54563C11.5546 6.62852 11.5994 6.80766 11.5166 6.94579C11.4919 6.98686 11.4576 7.02122 11.4166 7.04584L6.00002 10.2957L0.583546 7.04584C0.445419 6.96294 0.400624 6.7838 0.483504 6.64567C0.508133 6.6046 0.542491 6.57024 0.583546 6.54563L1.28477 6.12487L6.00002 8.95404L10.7153 6.12487ZM6.30015 0.763301L11.4166 3.83313C11.5546 3.916 11.5994 4.09516 11.5166 4.23329C11.4919 4.27434 11.4576 4.3087 11.4166 4.33333L6.00002 7.5832L0.583546 4.33333C0.445419 4.25046 0.400624 4.0713 0.483504 3.93317C0.508133 3.89211 0.542491 3.85776 0.583546 3.83313L5.6999 0.763301C5.88464 0.652467 6.11541 0.652467 6.30015 0.763301ZM6.00002 1.94379L2.4343 4.08323L6.00002 6.22269L9.56577 4.08323L6.00002 1.94379Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}

/**
 * Materials badge — stacked layers on their fixed-colour tile.
 * Design: 36×36 container (#81F1FF) + glyph (#1D94A3). Used by CiqIconBox.
 */
export function MaterialTileCiqIcon({
  size = 36,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="4" fill="#81F1FF" />
      <path
        d="M26.4836 21.022L27.7452 21.7427C27.9936 21.8847 28.0742 22.1915 27.9252 22.4281C27.8808 22.4984 27.819 22.5573 27.7452 22.5995L18.5399 27.8575C18.2076 28.0475 17.7924 28.0475 17.46 27.8575L8.25485 22.5995C8.00634 22.4575 7.92575 22.1506 8.07486 21.914C8.11917 21.8437 8.18099 21.7848 8.25485 21.7427L9.51646 21.022L18 25.8679L26.4836 21.022ZM26.4836 16.3259L27.7452 17.0466C27.9936 17.1886 28.0742 17.4954 27.9252 17.732C27.8808 17.8024 27.819 17.8612 27.7452 17.9034L18 23.4699L8.25485 17.9034C8.00634 17.7614 7.92575 17.4546 8.07486 17.218C8.11917 17.1476 8.18099 17.0888 8.25485 17.0466L9.51646 16.3259L18 21.1719L26.4836 16.3259ZM18.5399 7.14238L27.7452 12.4005C27.9936 12.5425 28.0742 12.8493 27.9252 13.0859C27.8808 13.1563 27.819 13.2151 27.7452 13.2573L18 18.8238L8.25485 13.2573C8.00634 13.1153 7.92575 12.8085 8.07486 12.5719C8.11917 12.5016 8.18099 12.4427 8.25485 12.4005L17.46 7.14238C17.7924 6.95254 18.2076 6.95254 18.5399 7.14238ZM18 9.16437L11.5847 12.8289L18 16.4935L24.4153 12.8289L18 9.16437Z"
        fill="#1D94A3"
      />
    </svg>
  );
}
